import { Component, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class FormComponent {

  @Input() formGroup: FormGroup = new FormGroup({
    text: new FormControl<string | null>(null)
  }) 

  ngOnInit() {
    console.log(this.formGroup);
  }

}
